import React from 'react'
import ButtonLink from '../../general/ButtonLink'
import Button from '../../general/Button'
import Translation from '../../Translation/cont/Translation'

const ListItem = ({
    title = false, 
    titleTransId = false,
    styles=false,
    type = false, 
    additionalClass  = false, 
    isSelected = false,
    isInApp= false,
    hasDisplayTimes = false,
    isOutOfRange = false,
    additionalButton='',
    pathnameEdit = false,
    onDelete = false
}) => {
    let wrapperClass = "item-poster-format cursor-pointer"

    if(additionalClass) {
        wrapperClass += ' ' + additionalClass
    }

    if(type) {
        wrapperClass += ' ' + type
    }

    if(isSelected) {
        wrapperClass += ' is-selected' 
    }

    if(isInApp) {
        wrapperClass += ' show-in-app-active'
    }

    if(hasDisplayTimes) {
        wrapperClass += ' has-display-times'
    }

    if(isOutOfRange) {
        wrapperClass += ' out-of-range'
    }



    return (
        <div className={wrapperClass}>
      
            {styles && <div className={"item-image"} style={styles}/>}


            {(title || titleTransId) && <div className="item-title-wrapper">
                {titleTransId ? (
                    <h4 className="item-title text-xsmall-light"><Translation id={titleTransId}/></h4>
                ) : (
                    <h4 className="item-title text-xsmall-light" dangerouslySetInnerHTML={{ __html: title}}></h4>
                )}
            </div>}

            {additionalButton}
    
            {pathnameEdit && <ButtonLink
                pathname={pathnameEdit}
                className="button button-edit"
                transId="edit_button"
            />}

            {onDelete && <Button
                className="button button-delete-item"
                transId="remove_button"
                onClick={onDelete}
            />}

            {isInApp && <div className='show-in-app-icon'>
                <span className='screen-reader-text'>Show In App Active</span>
            </div>}
        </div>
    )
}

export default ListItem